module.exports = __webpack_public_path__ + "media/src/images/invoice-04-2a56a6b64d3690229afc161424822905.png";